import React, { useEffect } from 'react';
import { Grid, Typography } from '@material-ui/core'
import { useDispatch, useSelector } from "react-redux";
import { fetchRemarks } from "../../../store/dcs"
import { ExitButton } from "../../../utils/etc";
import _ from 'lodash';

function getModalStyle() {

  return {
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
  };
}

const RemarksModal = (props) => {
  const modal = props.modalClasses
  const closeModal = props.closeModal
  const [modalStyle] = React.useState(getModalStyle);
  const dispatch = useDispatch();
  
  const remarks = useSelector(state => state.entities.dcs.remarks)
  
  useEffect(() => {
    if (!remarks.length) {
      dispatch(fetchRemarks(props.pax.PNRRefNo))
    }
  }, [remarks]);

  return (

    <div style={modalStyle} className={modal.paperBasic}>
      <ExitButton exit={closeModal} />
      <h2 id="simple-modal-title">Remarks for {props.pax.PNRRefNo}</h2>
      {!!remarks.length ? remarks.map((remark, index) => {
        return index % 2 ? (
          <Grid className={modal.bg0} item xs={12}>
            <Typography>{remark.PNRData}</Typography>
          </Grid>
        ) : 
        (
          <Grid className={modal.bg1 + index%2} item xs={12}>
            <Typography>{remark.PNRData}</Typography>
          </Grid>
        )
      }) : 'Loading'}
    </div>
  )
};

export default RemarksModal;